import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "216",
  height: "105",
  fill: "none",
  viewBox: "0 0 216 105",
  preserveAspectRatio: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M216 0C194.207 1.90232e-06 156.719 0.000301605 120.902 41.0456C100.075 64.9128 57.1845 104.511 3.70972e-05 104.511L43.6342 104.516H216V0Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }